import { AssignmentDistrictService } from './../../service/assignment-district.service';
import { FacilityService } from './../../../../core/services/facility.service';
import { deepCopy, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { GlobalConstants } from './../../../../core/constants/global-constants.constant';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { AssignmentDistrictMaintenanceTableData } from './interfaces/assignment-district-maintenance-table-data';
import { AssignmentDistrictMaintenanceTableColumn } from './interfaces/assignment-district-maintenance-table-column';
import { Option } from './interfaces/option';
import { SessionBaseComponent } from './../../../../shared/components/session.base.component';
import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Table } from 'primeng/table';
import { PageInfo } from 'src/app/core/models/page-info';
import { SortOrder } from 'src/app/core/interface/sort-order';
import { AssignmentDistrictMaintenanceGetRequest } from './interfaces/assignment-district-maintenance-get-request';
import { throwError } from 'rxjs';
import { AssignmentDistrictMaintenanceSaveRequest } from './interfaces/assignment-district-maintenance-save-request';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { LocationOption } from 'src/app/shared/components/model/LocationOption';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';

@Component({
  selector: 'laas-assignment-district-maintenance',
  templateUrl: './assignment-district-maintenance.component.html',
  styleUrls: ['./assignment-district-maintenance.component.scss']
})
export class AssignmentDistrictMaintenanceComponent extends SessionBaseComponent implements OnInit {
  readonly viewPermissionCode = PermissionConstants.AssignmentDistrictMaintenance;
  currentLang: string = this.laasSetting.language;
  // Status for the Query Form is open or not
  isSearchFormOpen = true;
  // The formGroup for the Query Form part
  searchFormGroup: FormGroup;

  // Options for Country dropdown list
  countryOptions: Option[] = [];
  tempCountryOptions: Option[] = [];
  // All options for City dropdown list
  allCityOptions: Option[] = [];
  // Options for City dropdown list of form
  formCityOptions: Option[] = [];
  // Options for City dropdown list of table by country
  tableCityOptions: Option[] = [];
  // Options for Facility dropdown list
  facilityOptions: Option[] = [];

  // Status for the loading circle on the table
  isLoading: boolean = false;
  // Status for enabling a user to edit the data on the table
  isInEditMode: boolean = false;
  // The table for table part
  @ViewChild('table') table!: Table;
  // All the columns of the table have
  tableColumns: AssignmentDistrictMaintenanceTableColumn[] = [
    { field: 'assignmentDistrictId', header: 'AssignmentDistrictMaintenance.Table.ColumnHeader.AssignmentDistrictId', sort: true },
    { field: 'facility', header: 'AssignmentDistrictMaintenance.Table.ColumnHeader.Facility', sort: true },
    { field: 'country', header: 'AssignmentDistrictMaintenance.Table.ColumnHeader.Country', sort: true },
    { field: 'citySeq', header: 'AssignmentDistrictMaintenance.Table.ColumnHeader.City', sort: true },
    { field: 'districtName', header: 'AssignmentDistrictMaintenance.Table.ColumnHeader.DistrictName', sort: true },
    { field: 'priority', header: 'AssignmentDistrictMaintenance.Table.ColumnHeader.Priority', sort: true },
    { field: 'createUser', header: 'AssignmentDistrictMaintenance.Table.ColumnHeader.CreateUser', sort: true },
    { field: 'createDt', header: 'AssignmentDistrictMaintenance.Table.ColumnHeader.CreateDt', sort: true },
    { field: 'updateUser', header: 'AssignmentDistrictMaintenance.Table.ColumnHeader.UpdateUser', sort: true },
    { field: 'updateDt', header: 'AssignmentDistrictMaintenance.Table.ColumnHeader.UpdateDt', sort: true }
  ];
  // The columns user choose to display
  selectedTableColumns: AssignmentDistrictMaintenanceTableColumn[] = [];
  // Current data on the table
  tableData: AssignmentDistrictMaintenanceTableData[] = [];
  // Backup data when data retrieved from the back-end
  backupTableData: AssignmentDistrictMaintenanceTableData[] = [];
  // User current selected row on the table
  selectedRow: AssignmentDistrictMaintenanceTableData | null;
  // User last selected row on the table
  previousSelectedRow: AssignmentDistrictMaintenanceTableData | null;

  // Records for user's operation on the table
  newAssignmentDistrictList: AssignmentDistrictMaintenanceTableData[] = [];
  updatedAssignmentDistrictList: AssignmentDistrictMaintenanceTableData[] = [];
  deletedAssignmentDistrictIdList: string[] = [];

  // For data key to distinguish the added rows on the table
  newDataKeyId: number = 0;
  // Table paging info
  pageInfo: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };
  // Table sorting info
  sortOrder: SortOrder = {
    property: "AssignmentDistrictId",
    direction: -1
  };

  constructor(
    private injector: Injector,
    private formBuilder: FormBuilder,
    private commonDataService: CommonDataService,
    private facilityService: FacilityService,
    private assignmentDistrictService: AssignmentDistrictService,
    private dropdownOptionsService: DropdownOptionsService
  ) {
    super(injector);
    this.searchFormGroup = this.formBuilder.group({
      assignmentDistrictId: null,
      searchLocation: [null],
      districtName: null,
      priority: null
    });

    this.selectedTableColumns = this.tableColumns;
    this.selectedRow = null;
    this.previousSelectedRow = this.selectedRow;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
  }

  @Input() get selectedColumns(): AssignmentDistrictMaintenanceTableColumn[] {
    return this.selectedTableColumns;
  }

  set selectedColumns(cols: AssignmentDistrictMaintenanceTableColumn[]) {
    // Filter display columns
    this.selectedTableColumns = this.tableColumns.filter(col => cols.includes(col));
  }

  onCountryOptionsReady(options: LocationOption[]): void {
    this.countryOptions = options;
    console.log(this.countryOptions);
  }

  onCityOptionsReady(options: LocationOption[]): void {
    this.allCityOptions = options;
    console.log(this.allCityOptions);
  }

  // Handle query button click on the query form
  searchBtnClick(): void {
    // Check if the priority on the query form is positive number
    if (!this.checkPriorityIsInRightFormat(this.searchFormGroup.value.priority)) {
      this.toastService.warn(this.translateService.instant('AssignmentDistrictMaintenance.Toast.WrongPriorityFormat'));
      return;
    }
    this.isSearchFormOpen = false;
    this.isInEditMode = false;
    this.isLoading = true;
    this.pageInfo.pageIndex = 0;
    this.table.first = 0;

    this.sendSearchRequest();
  }

  // Send Get request to service class for retrieve data
  sendSearchRequest(): void {
    this.restoreData();
    const getRequest: AssignmentDistrictMaintenanceGetRequest = {
      assignmentDistrictId: this.searchFormGroup.value.assignmentDistrictId,
      country: this.searchFormGroup.value.searchLocation?.country || null,
      citySeqNo: this.convertEmptyNumberArrayToNull(this.searchFormGroup.value.searchLocation?.city) || null,
      districtName: this.searchFormGroup.value.districtName,
      priority: this.searchFormGroup.value.priority,
      pageIndex: this.pageInfo.pageIndex,
      pageSize: this.pageInfo.pageSize,
      sortOrder: this.sortOrder
    }

    this.assignmentDistrictService.getAssignmentDistrict(getRequest)
      .subscribe({
        next: (response) => {
          this.isLoading = false;
          this.table.cancelRowEdit(this.selectedRow);
          if (!isNullOrEmpty(response)) {

            //Update table
            if (!isNullOrEmpty(response.content)) {
              this.tableData = deepCopy(response.content)!;
              this.backupTableData = deepCopy(this.tableData)!;
              this.selectedRow = this.tableData[0];
            }
            else {
              this.tableData = [];
              this.backupTableData = [];
              this.selectedRow = null;
            }

            this.previousSelectedRow = this.selectedRow;
            this.updateTableHighlight(this.selectedRow);

            if (this.isInEditMode) {
              this.table.initRowEdit(this.selectedRow);
            }

            // Change page Info
            this.pageInfo.totalRecords = response.totalElements;
            this.pageInfo.totalPages = this.pageInfo.totalRecords / this.pageInfo.pageSize;

          }
          else {
            throw throwError(response);
          }
        },
        error: response => {
          this.isLoading = false;
          this.tableData = [];
          this.backupTableData = [];
          this.selectedRow = null;
          this.previousSelectedRow = this.selectedRow;
          this.pageInfo.totalRecords = 0;
          this.pageInfo.totalPages = 0;

          // Handle Error Msg
          // Find error list of assignment district
          let errorCode = response.error.errorCode;
          let category = response.error.category;
          this.commonDataService.getErrorCodes(this.laasSetting.language, category).subscribe({
            next: (errorList) => {
              // find error that has the errorCode in  errorList
              let matchedError = errorList.find((error: any) => error.errorCode == errorCode)
              this.toastService.error(matchedError.errorMsg)
            }
          })
        }
      });
  }


  /**
   * Create city options from response
   */
  private createCityOptionList(response: any): Option[] {
    let cityOptions: Option[] = [];
    for (const city of response) {
      if (this.laasSetting.language == GlobalConstants.defaultLanguage) {
        cityOptions.push({
          label: `${city.seqNo} - ${city.name}`,
          value: Number(city.seqNo)
        })
      }
      else {
        cityOptions.push({
          label: `${city.seqNo} - ${city.enName}`,
          value: Number(city.seqNo)
        })
      }
    }
    return cityOptions;
  }

  private convertEmptyNumberArrayToNull(value: number[]): number[] | null {
    if (isNullOrEmpty(value) || value.length <= 0) {
      return null;
    }
    return value;
  }

  addNewRow(): void {
    // Prohibit user to add a new row before user fill the required data well
    if (!this.isUserInputValid(this.previousSelectedRow)) {
      return;

    }

    // Add a new row to table's first row
    this.tableData.splice(0, 0, {
      assignmentDistrictId: null, facility: this.laasSetting.facility, country: null,
      citySeqNo: null, districtName: null, priority: null,
      createUser: this.userService.userInfo.userName, createDt: new Date(),
      updateUser: this.userService.userInfo.userName, updateDt: new Date(),
      dataKey: `--${this.newDataKeyId++}`
    });

    // Change the current editing row to the added row
    this.clearTableEdit()
    if (!isNullOrEmpty(this.selectedRow)) {
      this.updateTableCityOption(this.selectedRow!.country!)
    }
    this.table.initRowEdit(this.selectedRow);

  }

  deleteSelectedRow(): void {
    this.confirmationService.confirm({
      message: this.translateService.instant('AssignmentDistrictMaintenance.Confirm.Delete'),
      header: this.translateService.instant('AssignmentDistrictMaintenance.Confirm.Header'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.table.cancelRowEdit(this.selectedRow);

        if (!isNullOrEmpty(this.selectedRow)) {
          const selectedRowIndex = this.tableData.indexOf(this.selectedRow!);
          if (selectedRowIndex > -1) {
            if (this.tableData[selectedRowIndex].dataKey[0] !== '-') {
              // Because user can't change dataKey, so dataKey will remain the same
              let dataKey = this.tableData[selectedRowIndex].dataKey;
              let id = dataKey.substring(0, dataKey.length - 2);
              this.addToDeletedList(id);
            }

            // Remove deleted row from table
            this.tableData.splice(selectedRowIndex, 1);

            // Change selected row
            if (selectedRowIndex != this.tableData.length) {
              // Change user current selected row to the next row of the deleted row
              this.selectedRow = this.tableData[selectedRowIndex];
            }
            else { // Deleted row is the last row of the current page
              // Change user current selected row to the previous row of the deleted row
              this.selectedRow = this.tableData[selectedRowIndex - 1];
            }
            this.previousSelectedRow = this.selectedRow;
            this.updateTableHighlight(this.selectedRow);

            if (!isNullOrEmpty(this.selectedRow)) {
              this.updateTableCityOption(this.selectedRow.country!)
            }

            this.table.initRowEdit(this.selectedRow);
            this.toastService.success(this.translateService.instant("AssignmentDistrictMaintenance.Toast.DeleteSuccess"));
          }
        }

      }
    });
  }

  saveChanges(): void {
    this.confirmationService.confirm({
      message: this.translateService.instant('AssignmentDistrictMaintenance.Confirm.Save'),
      header: this.translateService.instant('AssignmentDistrictMaintenance.Confirm.Header'),
      icon: 'pi pi-info-circle',
      accept: () => {
        // Prohibit user to save row if user doesn't fill the required data on the newly added row
        if (!this.isUserInputValid(this.selectedRow))
          return;

        this.isLoading = true;

        // Check user's operations on the table
        this.checkNewAndUpdatedRow();
        const savedData: AssignmentDistrictMaintenanceSaveRequest = {
          newAssignmentDistrictList: this.newAssignmentDistrictList,
          updatedAssignmentDistrictList: this.updatedAssignmentDistrictList,
          deletedAssignmentDistrictIdList: this.deletedAssignmentDistrictIdList
        }

        this.assignmentDistrictService.saveAssignmentDistrictMaintenanceChanges(savedData).subscribe({
          next: () => {
            this.table.cancelRowEdit(this.selectedRow);
            this.isInEditMode = false;

            this.sendSearchRequest();
            this.toastService.success(this.translateService.instant("AssignmentDistrictMaintenance.Toast.SaveSuccess"));
          },
          error: (response) => {
            this.isLoading = false;
            this.newAssignmentDistrictList = [];
            this.updatedAssignmentDistrictList = [];

            this.toastErrorMessage(response.error)
          }
        });
      }
    })
  }

  restoreTableData(): void {
    this.confirmationService.confirm({
      message: this.translateService.instant('AssignmentDistrictMaintenance.Confirm.Restore'),
      header: this.translateService.instant('AssignmentDistrictMaintenance.Confirm.Header'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.restoreData();

        // Update table to last saved data
        this.tableData = deepCopy(this.backupTableData)!;
        this.clearTableEdit();
        if (!isNullOrEmpty(this.selectedRow)) {
          this.updateTableCityOption(this.selectedRow!.country!)
        }
        this.table.initRowEdit(this.selectedRow);

        this.toastService.success(this.translateService.instant('AssignmentDistrictMaintenance.Toast.RestoreSuccess'))
      }
    })
  }

  switchEditMode(): void {
    if (this.isInEditMode) {
      this.confirmationService.confirm({
        message: this.translateService.instant('AssignmentDistrictMaintenance.Confirm.Exit'),
        header: this.translateService.instant('AssignmentDistrictMaintenance.Confirm.Header'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.isInEditMode = false;
          this.restoreData();

          // Update table to last saved data
          this.tableData = deepCopy(this.backupTableData)!;
          this.clearTableEdit();

          this.toastService.success(this.translateService.instant('AssignmentDistrictMaintenance.Toast.ExitSuccess'))
        }
      })
    }
    else {
      this.isInEditMode = true;
      if (!isNullOrEmpty(this.selectedRow)) {
        this.updateTableCityOption(this.selectedRow!.country!)
        this.table.initRowEdit(this.selectedRow);
      }
    }
  }

  async onRowSelect(rowData: AssignmentDistrictMaintenanceTableData) {
    if (this.isInEditMode) {
      // Keep the selectedRow variable is pointing at the user's selected row
      // Whether is select or deselect
      this.selectedRow = rowData;

      // Reselect after user click on the same row
      if (this.previousSelectedRow != null && this.selectedRow.dataKey == this.previousSelectedRow.dataKey) {
        this.updateTableHighlight(this.previousSelectedRow);
        return;
      }

      if (this.isUserInputValid(this.previousSelectedRow)) {
        // Change the current selected row to the user's selected row
        this.table.cancelRowEdit(this.previousSelectedRow)
        this.table.initRowEdit(this.selectedRow);
        this.previousSelectedRow = this.selectedRow;
      }
      else {
        // Rollback the selected row to the row which doesn't fill the required data well
        this.selectedRow = this.previousSelectedRow;
        this.updateTableHighlight(this.selectedRow);
      }
      this.updateTableCityOption(this.selectedRow!.country!)
    }
    else {
      this.previousSelectedRow = this.selectedRow;
    }
  }

  // Check priority is positive number
  checkPriorityIsInRightFormat(priority: number): boolean {
    // Check if not a number / include a decimal point / include scientific notation / negative number
    if (!isNullOrEmpty(priority)) {
      if (isNaN(priority) || priority.toString().includes('.') ||
        priority.toString().includes('e') || priority < 0) {
        return false;
      }
    }

    return true;
  }

  onTablePageChanging(event: { first: number, rows: number }) {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / event.rows;
    this.isLoading = true;
    this.sendSearchRequest();
  }

  onTableSorting(event: { field: string, order: number }) {
    if (this.tableData.length != 0) {
      this.sortOrder.property = event.field;
      this.sortOrder.direction = event.order;
      this.isLoading = true;
      this.sendSearchRequest();
    }
  }

  tableSelectedCountryChanged(event: { value: string }, rowData: AssignmentDistrictMaintenanceTableData) {
    this.clearRelatedRowValue(rowData);
    this.updateTableCityOption(event.value);
  }

  private isUserInputValid(rowData: AssignmentDistrictMaintenanceTableData | null) {
    if (rowData) {
      if (rowData.assignmentDistrictId == null || rowData.assignmentDistrictId.trim().length <= 0) {
        this.toastService.warn(this.translateService.instant("AssignmentDistrictMaintenance.Toast.EmptyDataError"));
        return false;
      }
      else if (!this.checkPriorityIsInRightFormat(rowData.priority!)) {
        this.toastService.warn(this.translateService.instant('AssignmentDistrictMaintenance.Toast.WrongPriorityFormat'));
        return false;
      }
    }
    return true;
  }

  // Cancel current table's row editing
  private clearTableEdit() {
    this.table.cancelRowEdit(this.selectedRow);
    this.selectedRow = this.tableData[0];
    this.previousSelectedRow = this.selectedRow;

    //Avoid the highlighted part leave on the previous row
    this.updateTableHighlight(this.selectedRow);
  }

  private restoreData(): void {
    // Clear user changed action
    this.newDataKeyId = 0;
    this.newAssignmentDistrictList = [];
    this.updatedAssignmentDistrictList = [];
    this.deletedAssignmentDistrictIdList = [];

    this.table.resetScrollTop();
  }

  private checkNewAndUpdatedRow(): void {
    let saveDataIndex = 0;

    if (saveDataIndex < this.tableData.length) {
      // Check if any added row by dataKey property
      // Added row's dataKey format : --id
      for (const tableData of this.tableData) {
        if (tableData.dataKey[0] != '-') {
          break;
        }
        this.addToNewAssignementDistrictList(tableData);
        saveDataIndex++;
      }

      // Reverse for maintain order of user adding new row
      this.newAssignmentDistrictList.reverse();

      // Compare backup table data to current table data
      for (const backupData of this.backupTableData) {
        let dataKey = backupData.dataKey;
        let id = dataKey.substring(0, dataKey.length - 2);
        if (this.deletedAssignmentDistrictIdList.indexOf(id) == -1) {
          let currentData = this.tableData[saveDataIndex]
          this.checkIsDifferentData(currentData, backupData);
          saveDataIndex++;
        }
      }
    }
  }

  private checkIsDifferentData(currentData: AssignmentDistrictMaintenanceTableData, backupData: AssignmentDistrictMaintenanceTableData) {
    if (this.checkIdChange(currentData.dataKey, currentData.assignmentDistrictId)) {
      this.addToNewAssignementDistrictList(currentData);
    }
    else if (JSON.stringify(currentData) != JSON.stringify(backupData)) {
      this.addToUpdateList(currentData);
    }
  }

  private checkIdChange(dataKey: string, id: string | null) {
    let previousId = dataKey.substring(0, dataKey.length - 2);
    if (id != null && previousId != id) {
      this.addToDeletedList(previousId);
      return true;
    }
    return false;
  }

  // Control the selection highlighting back to the row
  private updateTableHighlight(currentRow: AssignmentDistrictMaintenanceTableData | null): void {
    if (!currentRow)
      return;
    this.table.selection = currentRow;
    this.table.selectionKeys = {};
    this.table.selectionKeys[currentRow.dataKey] = 1;
    this.table.tableService.onSelectionChange();
  }

  private addToNewAssignementDistrictList(rowData: AssignmentDistrictMaintenanceTableData): void {
    this.newAssignmentDistrictList.push(rowData);
  }

  private addToUpdateList(rowData: AssignmentDistrictMaintenanceTableData): void {
    rowData.updateUser = this.userService.userInfo.userName;
    rowData.updateDt = new Date();
    this.updatedAssignmentDistrictList.push(rowData);
  }

  private addToDeletedList(id: string): void {
    this.deletedAssignmentDistrictIdList.push(id);
  }

  /**
   * Clear related row value when user edit country on the table
   */
  private clearRelatedRowValue(rowData: AssignmentDistrictMaintenanceTableData) {
    rowData.citySeqNo = null;
  }

  /**
   * Update table city dropdown list option that binded with country
   */
  private updateTableCityOption(country: string): void {
    this.commonDataService.getCityByCountry(country).subscribe({
      next: (response) => {
        this.tableCityOptions = this.createCityOptionList(response);
      }
    })
  }
}
